import { render, staticRenderFns } from "./ShareVideoPages.vue?vue&type=template&id=50b08f15&scoped=true&"
import script from "./ShareVideoPages.vue?vue&type=script&lang=js&"
export * from "./ShareVideoPages.vue?vue&type=script&lang=js&"
import style0 from "./ShareVideoPages.vue?vue&type=style&index=0&id=50b08f15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b08f15",
  null
  
)

export default component.exports